/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import MeshSpiralMaterial from './materials/MeshSpiralMaterial'
import { useFrame } from '@react-three/fiber'
import { useControls } from 'leva'

export default function FlashSpiral(props) 
{
    const self = useRef()

    const colorFront = '#022028'
    const colorBack = '#3DF5FF'
       

    const { nodes } = useGLTF('./models/orb.glb')

    useFrame( ( state, delta ) =>
    {
        const time = state.clock.getElapsedTime() * 4.97
        const scale = 0.1 * Math.sin(time) + 0.9

        self.current.rotation.y += delta * 3
        self.current.scale.set( scale, scale, scale )
    })


    return (
        <group {...props} dispose={null}>
            <mesh name="Sphere" geometry={nodes.Sphere.geometry} ref={ self }>
                <MeshSpiralMaterial
                    frontColor={ colorFront }
                    backColor={ colorBack }
                    colorBoth={ true }
                    intensity={ 1.3 }
                />
            </mesh>
        </group>
    )
}

useGLTF.preload('./models/orb.glb')